import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [RouterModule.forChild([        
        { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./item-produto-listar/item-produto-listar.module').then(m => m.ItemProdutoListarModule) },
        { path: 'inserir', data: { breadcrumb : 'Novo' }, loadChildren: () => import('./item-produto-inserir/item-produto-inserir.module').then(m => m.ItemProdutoInserirModule) },
        { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./item-produto-editar/item-produto-editar.module').then(m => m.ItemProdutoEditarModule) },
        { path: 'detalhar', data: { breadcrumb : 'Detalhar' }, loadChildren: () => import('./item-produto-detalhar/item-produto-detalhar.module').then(m => m.ItemProdutoDetalharModule) }

    
    ])],
    exports: [RouterModule]
})
export class ItemProdutoAppRoutingModule { }